export default __webpack_public_path__ + "static/media/pvn-arte-5.9287805d.webp";